/**
 * Convert a backend-served file URL (e.g. "/api/uploads/files/<id>") to an
 * absolute URL the browser can hit. Pass-through for already-absolute URLs.
 *
 * Uses the same smart-resolution logic as `lib/api.js` so that when the user
 * browses under a custom domain (e.g. `synergy-table.com`) while the build
 * embedded a different host, asset URLs stay same-origin and authenticated.
 */
import { API_BASE } from "./api";

// Strip the trailing "/api" → just the backend origin.
const BACKEND_URL = API_BASE.replace(/\/api$/, "");

export function resolveAssetUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
